import {useMutation, useQueryClient} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {PostFavoriteDoctorRequest} from 'domain/usecases';
import {postFavoriteDoctor} from '../services/postFavoriteDoctor';

export function usePostFavoriteDoctorMutation() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({
			cdEspecialidade,
			cdSubEspecialidade,
			cdPrestador,
			signal,
		}: PostFavoriteDoctorRequest) =>
			postFavoriteDoctor({cdEspecialidade, cdSubEspecialidade, cdPrestador, signal}),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.HEALTH_GUIDE_FAVORITE_DOCTORS],
				refetchType: 'none',
			});
			queryClient.refetchQueries({
				queryKey: [QUERY_KEYS.HOME],
			});
		},
	});
}
